// test1421
(1421 && 0);
